import { useDrag as useReactDndDrag } from 'react-dnd';
import type { DragSourceMonitor as ReactDndDragSourceMonitor } from 'react-dnd';

import type { CustomDraggableItem, DropResult } from '../types';

type DragSourceMonitor = ReactDndDragSourceMonitor<
  CustomDraggableItem | null,
  DropResult
>;

type UseDragParams<T extends CustomDraggableItem, CollectedProps> = {
  item: T;
  canDrag?: boolean | ((monitor: DragSourceMonitor) => boolean);
  collect?: (monitor: DragSourceMonitor) => CollectedProps;
  isDragging?: (monitor: DragSourceMonitor) => boolean;
  onDragStart?: (monitor: DragSourceMonitor) => void | null;
  onDragEnd?: (draggedItem: T, monitor: DragSourceMonitor) => void | undefined;
};

export const useDrag = <
  T extends CustomDraggableItem,
  CollectedProps = unknown,
>({
  item,
  canDrag,
  collect,
  isDragging,
  onDragStart,
  onDragEnd,
}: UseDragParams<T, CollectedProps>) =>
  useReactDndDrag(
    () => ({
      type: item.draggableItemType,
      item: (monitor) => {
        if (onDragStart) {
          const dragStartReturn = onDragStart(monitor);
          if (dragStartReturn === null) return dragStartReturn;
        }
        return item;
      },
      canDrag,
      collect,
      isDragging,
      end: onDragEnd,
    }),
    [item, canDrag, collect, isDragging, onDragStart, onDragEnd],
  );
